import styled from '@emotion/styled'
import { Typography } from '@material-ui/core'

const Title = styled(Typography)`
  padding: ${({ theme }) => theme.spacing(2.5, 4)};
  line-height: 1;
`

export { Title }
